import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { getCurrentUser } from "../firebase/authMethods"; 
import { resetPassword } from "../firebase/authMethods"; 
import { logOut } from "../firebase/authMethods";
import { saveMarketingPreference } from "../firebase/authMethods";

import currency from "../images/moneybag.png"
import empty from "../images/Empty.png"
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from 'firebase/auth';  
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import useMediaQuery from '@mui/material/useMediaQuery';
import InfoIcon from '@mui/icons-material/Info';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const USERNAME_MIN_LENGTH = 3;
const USERNAME_MAX_LENGTH = 20;
const BETS_PER_PAGE = 30;
const ACCOUNT_TAB_STORAGE_KEY = 'fantasybet.accountTab';

const formatBetHistoryDate = (date) => new Date(date).toLocaleDateString(undefined, {
  day: 'numeric',
  month: 'numeric',
  year: '2-digit',
});

const normalizeSearchText = (value) => String(value ?? '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/ł/g, 'l')
  .replace(/ø/g, 'o')
  .replace(/đ/g, 'd')
  .replace(/æ/g, 'ae')
  .replace(/œ/g, 'oe')
  .replace(/ß/g, 'ss');

const measureMinimumTableWidth = (table) => {
  const measurementTable = table.cloneNode(true);
  Object.assign(measurementTable.style, {
    position: 'fixed',
    left: '-10000px',
    top: '0',
    width: 'min-content',
    minWidth: '0',
    maxWidth: 'none',
    tableLayout: 'auto',
    visibility: 'hidden',
    pointerEvents: 'none',
  });
  document.body.appendChild(measurementTable);
  const minimumWidth = Math.ceil(measurementTable.getBoundingClientRect().width);
  measurementTable.remove();
  return minimumWidth;
};

function BetHistoryFilter({ filterType, setFilterType, className = '' }) {
  return (
    <div className={`selectDiv ${className}`} onClick={(event) => event.stopPropagation()}>
      <div className="btn-group">
        <button type="button" className="select dropdown-toggle text-capitalize d-flex justify-content-between" data-bs-toggle="dropdown" aria-expanded="false">
          <span>{filterType}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
          </svg>
        </button>
        <ul className="dropdown-menu dropdown-menu-end">
          <li><button className="dropdown-item" type="button" onClick={() => setFilterType('all')}>All</button></li>
          <li><button className="dropdown-item" type="button" onClick={() => setFilterType('settled')}>Settled</button></li>
          <li><button className="dropdown-item" type="button" onClick={() => setFilterType('pending')}>Pending</button></li>
        </ul>
      </div>
    </div>
  );
}

export default function AccountSettings({user, setUser, walletBalance, setWalletBalance, setIsPremium, openAddCoinsModal, closeAddCoinsModal, coinsToAdd, usernameInfo, setUsernameInfo, setBetsOpen, setLoading, handleClearAllBets, setRole}) {
  const [reset, setReset] = useState(false)
  const [switcher, setSwitcher] = useState(() => {
    try {
      return localStorage.getItem(ACCOUNT_TAB_STORAGE_KEY) === 'account' ? 'account' : 'bets';
    } catch {
      return 'bets';
    }
  });
  const [betHistory, setBetHistory] = useState([]);
  const [netProfit, setNetProfit] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder, setSortOrder] = useState('desc');
  const [filterType, setFilterType] = useState('all');
  const [message, setMessage] = useState("");
  const [order, setOrder] = useState("");
  const [sortedBets, setSortedBets] = useState([]);
  const [betHistoryPage, setBetHistoryPage] = useState(1);
  const [isBetHistoryCardView, setIsBetHistoryCardView] = useState(false);
  const [isBetHistoryDataLoading, setIsBetHistoryDataLoading] = useState(true);
  const [isBetHistoryLayoutPending, setIsBetHistoryLayoutPending] = useState(true);
  const betHistoryTableWrapRef = useRef(null);
  const betHistoryTableRef = useRef(null);
  const hasStartedBetHistoryLoadRef = useRef(false);
  const hasCompletedInitialBetHistoryLayoutRef = useRef(false);
  const [marketingOptIn, setMarketingOptIn] = useState(false);
  const [marketingPreferenceLoading, setMarketingPreferenceLoading] = useState(true);
  const [marketingPreferenceMessage, setMarketingPreferenceMessage] = useState('');
  const [walletInfoPinned, setWalletInfoPinned] = useState(false);
  const [walletInfoHovered, setWalletInfoHovered] = useState(false);
  const [usernameDraft, setUsernameDraft] = useState(usernameInfo || '');
  const [usernameEditing, setUsernameEditing] = useState(false);
  const usernameInputRef = useRef(null);
  const usernameCheckRequestRef = useRef(0);
  const [usernameSaving, setUsernameSaving] = useState(false);
  const [usernameChecking, setUsernameChecking] = useState(false);
  const [usernameAvailable, setUsernameAvailable] = useState(null);
  const [usernameMessage, setUsernameMessage] = useState('');
  const isPhone = useMediaQuery('(max-width: 600px)');
  const navigate = useNavigate();

  useEffect(() => {
    try {
      localStorage.setItem(ACCOUNT_TAB_STORAGE_KEY, switcher);
    } catch {
      // Tabs still work when browser storage is unavailable.
    }
  }, [switcher]);

  useLayoutEffect(() => {
    const tableWrap = betHistoryTableWrapRef.current;
    const table = betHistoryTableRef.current;
    if (switcher !== 'bets') return undefined;
    if (!tableWrap || !table) {
      if (!isBetHistoryDataLoading) {
        hasCompletedInitialBetHistoryLayoutRef.current = true;
        setIsBetHistoryLayoutPending(false);
      }
      return undefined;
    }

    let animationFrame;
    const delayedChecks = [];
    const updateCardView = () => {
      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(() => {
        const visualViewportWidth = window.visualViewport?.width;
        const availableWidth = Math.min(
          tableWrap.clientWidth,
          visualViewportWidth || tableWrap.clientWidth
        );
        const requiredWidth = measureMinimumTableWidth(table);
        const isCurrentlyTable = !tableWrap.classList.contains('is-card-view');
        const hasHorizontalOverflow = isCurrentlyTable
          && tableWrap.scrollWidth > tableWrap.clientWidth + 1;
        const shouldUseCards = hasHorizontalOverflow || requiredWidth > availableWidth + 1;

        setIsBetHistoryCardView((currentValue) => (
          currentValue === shouldUseCards ? currentValue : shouldUseCards
        ));
        if (!isBetHistoryDataLoading && !hasCompletedInitialBetHistoryLayoutRef.current) {
          hasCompletedInitialBetHistoryLayoutRef.current = true;
          setIsBetHistoryLayoutPending(false);
        }
      });
    };

    updateCardView();
    delayedChecks.push(setTimeout(updateCardView, 50));
    delayedChecks.push(setTimeout(updateCardView, 250));

    const resizeObserver = new ResizeObserver(updateCardView);
    resizeObserver.observe(tableWrap);
    resizeObserver.observe(table);

    const mutationObserver = new MutationObserver(updateCardView);
    mutationObserver.observe(table, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    document.fonts?.addEventListener('loadingdone', updateCardView);
    window.addEventListener('resize', updateCardView);
    window.addEventListener('orientationchange', updateCardView);
    window.addEventListener('pageshow', updateCardView);
    window.visualViewport?.addEventListener('resize', updateCardView);

    return () => {
      cancelAnimationFrame(animationFrame);
      delayedChecks.forEach(clearTimeout);
      resizeObserver.disconnect();
      mutationObserver.disconnect();
      document.fonts?.removeEventListener('loadingdone', updateCardView);
      window.removeEventListener('resize', updateCardView);
      window.removeEventListener('orientationchange', updateCardView);
      window.removeEventListener('pageshow', updateCardView);
      window.visualViewport?.removeEventListener('resize', updateCardView);
    };
  }, [isBetHistoryDataLoading, sortedBets, switcher]);

  useEffect(() => {
    setUsernameDraft(usernameInfo || '');
  }, [usernameInfo]);


  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        navigate("/");
        setUser(null)
      } else {
        setUser(currentUser);
      }
    });

    return () => unsubscribe(); 
  }, [navigate]);
  
  useEffect(() => {
    if(user) {
      getBetsHistory();
    }
    
  }, [user, walletBalance]);

  useEffect(() => {
    let cancelled = false;

    const fetchMarketingPreference = async () => {
      if (!user) return;
      setMarketingPreferenceLoading(true);
      try {
        const token = await user.getIdToken();
        const response = await fetch('/api/marketing-preference', {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to load marketing preference.');
        if (!cancelled) setMarketingOptIn(Boolean(data.marketingOptIn));
      } catch (error) {
        console.error('Error fetching marketing preference:', error);
        if (!cancelled) setMarketingPreferenceMessage('Unable to load your marketing preference.');
      } finally {
        if (!cancelled) setMarketingPreferenceLoading(false);
      }
    };

    fetchMarketingPreference();
    return () => { cancelled = true; };
  }, [user]);

  const handleMarketingPreferenceChange = async (nextValue) => {
    setMarketingPreferenceLoading(true);
    setMarketingPreferenceMessage('');
    try {
      await saveMarketingPreference(user, nextValue);
      setMarketingOptIn(nextValue);
      setMarketingPreferenceMessage(nextValue
        ? 'Marketing emails enabled.'
        : 'Marketing emails disabled.');
    } catch (error) {
      console.error('Error updating marketing preference:', error);
      setMarketingPreferenceMessage('Unable to update your preference. Try again.');
    } finally {
      setMarketingPreferenceLoading(false);
    }
  };
  
  const handleLogOut = async () => {
    logOut()
    .then(() => {
      setUsernameInfo('')
      setUser(null);
      setBetsOpen(false);
      handleClearAllBets();
      setLoading(false);
      setIsPremium({
        isPremium: false,
        isPremiumTrial: false,
        trialExpiresAt: null,
      })
      setRole(null)
      localStorage.setItem('username', '');
      localStorage.setItem('walletBalance', 0)


      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    })
    .catch((error) => {
      setLoading(false);
    });
  }


  useEffect(() => {
    const verifyPayment = async () => {
      const query = new URLSearchParams(window.location.search);
      const sessionId = query.get("session_id");
      
      if (query.get("success") && sessionId) {
        setOrder("processing");
        setMessage("Payment received. Updating your account...");
        try {
          const token = await user.getIdToken();
          const response = await fetch('/api/verify-payment', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ sessionId }),
          });
          const data = await response.json();

          if (response.ok && data.isValid) {
            setMessage(data.alreadyProcessed
              ? "This payment was already applied to your account."
              : "Payment completed and your account has been updated.");
            setOrder("success");
            setWalletBalance(data.wallet_balance);
            localStorage.setItem("walletBalance", data.wallet_balance);
            if (data.premiumChange) {
              setIsPremium({ isPremium: true, isPremiumTrial: false, trialExpiresAt: null });
            }
          } else {
            setOrder("failed");
            setMessage(data.message || "Payment could not be verified. Please contact support.");
          }
        } catch (error) {
          console.error("Error verifying payment:", error);
          setOrder("failed");
          setMessage("We could not verify the payment. Please refresh and try again.");
        }
      } else if (query.get("cancelled")) {
        setOrder("cancelled")
        setMessage("Order cancelled.");
      }
      window.history.replaceState({}, document.title, "/account");
    };

    if(user) {
      verifyPayment();
    }
  }, [user, setIsPremium, setWalletBalance]);

  const handleResetPassword = async () => {
    const currentUser = await getCurrentUser();
    let email = currentUser.email
    if (email){
      resetPassword(email);
      setReset(true)
      setTimeout(() => {
        setReset(false);
      }, 60000);
    }
  };
  const getBetsHistory = async () => {
    const isInitialPageLoad = !hasStartedBetHistoryLoadRef.current;
    if (isInitialPageLoad) {
      hasStartedBetHistoryLoadRef.current = true;
      setIsBetHistoryDataLoading(true);
    }
    try {
      const token = await user.getIdToken(); 

      const response =  await fetch('/api/bets-history', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify({user}),
      });
      const data = await response.json();
      // console.log("bets history:", data )
      const results = Array.isArray(data.results) ? data.results : [];
      setBetHistory(results);
      setNetProfit(Number(data.netProfit) || 0);
      filterBets(results);
    } catch (error) {
      console.error('Error fetching user data', error);
      setBetHistory([]);
      setNetProfit(0);
      setSortedBets([]);
    } finally {
      if (isInitialPageLoad) setIsBetHistoryDataLoading(false);
    }
  };

useEffect(() => {
  filterBets(betHistory)
}, [betHistory, filterType, searchTerm, sortOrder])

useEffect(() => {
  setBetHistoryPage(1);
}, [betHistory, filterType, searchTerm, sortOrder]);


function filterBets(betHistory){

  if(!Array.isArray(betHistory)) return [];
  
  const uniqueBets = Array.from(new Map(betHistory.map(bet => [bet.bet_id, bet])).values());
  const normalizedSearchTerm = normalizeSearchText(searchTerm);

  const filteredBets = uniqueBets.filter((bet) => {
    const matchesSearch = [bet.bet_type, bet.fixture, bet.bet_market]
      .some((value) => normalizeSearchText(value).includes(normalizedSearchTerm));
  
    const matchesFilter = filterType === 'settled' ? (bet.status === 'won' || bet.status === 'lost' || bet.status === 'void')
      : filterType === 'pending' ? (bet.status === 'pending')
      : true; 
  
    return matchesSearch && matchesFilter;
  });
  
  const sortedBets = filteredBets.sort((a, b) => {
    const dateA = new Date(a.placed_at);
    const dateB = new Date(b.placed_at);
    return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
  });
  setSortedBets((currentBets) => {
    const isSameResult = currentBets.length === sortedBets.length
      && currentBets.every((bet, index) => bet === sortedBets[index]);
    return isSameResult ? currentBets : sortedBets;
  });
}


  const toggleSortOrder = () => {
    setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
  };

  const totalBetHistoryPages = Math.max(1, Math.ceil(sortedBets.length / BETS_PER_PAGE));
  const safeBetHistoryPage = Math.min(betHistoryPage, totalBetHistoryPages);
  const firstBetIndex = (safeBetHistoryPage - 1) * BETS_PER_PAGE;
  const paginatedBets = sortedBets.slice(firstBetIndex, firstBetIndex + BETS_PER_PAGE);

  const changeBetHistoryPage = (nextPage) => {
    const boundedPage = Math.min(Math.max(nextPage, 1), totalBetHistoryPages);
    setBetHistoryPage(boundedPage);
    requestAnimationFrame(() => {
      if (betHistoryTableWrapRef.current) betHistoryTableWrapRef.current.scrollTop = 0;
    });
  };

  const checkUsernameAvailability = async (username) => {
    if (username.toLowerCase() === String(usernameInfo || '').trim().toLowerCase()) return true;

    const response = await fetch('/api/check-username', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Unable to check username availability.');
    return !data.exists;
  };

  const handleUsernameEdit = () => {
    usernameCheckRequestRef.current += 1;
    setUsernameDraft(usernameInfo || '');
    setUsernameAvailable(null);
    setUsernameMessage('');
    setUsernameChecking(false);
    setUsernameEditing(true);
    requestAnimationFrame(() => usernameInputRef.current?.focus());
  };

  const handleUsernameCancel = () => {
    if (usernameSaving) return;
    usernameCheckRequestRef.current += 1;
    setUsernameDraft(usernameInfo || '');
    setUsernameAvailable(null);
    setUsernameMessage('');
    setUsernameChecking(false);
    setUsernameEditing(false);
  };

  const handleUsernameBlur = async () => {
    if (!usernameEditing || usernameSaving) return;
    const nextUsername = usernameDraft.trim();
    if (
      nextUsername.length < USERNAME_MIN_LENGTH
      || nextUsername.length > USERNAME_MAX_LENGTH
      || nextUsername === usernameInfo
    ) return;

    const requestId = ++usernameCheckRequestRef.current;
    setUsernameChecking(true);
    setUsernameMessage('Checking availability…');
    try {
      const isAvailable = await checkUsernameAvailability(nextUsername);
      if (requestId !== usernameCheckRequestRef.current) return;
      setUsernameAvailable(isAvailable);
      setUsernameMessage(isAvailable ? 'Username is available.' : 'Username is already taken.');
    } catch (error) {
      if (requestId !== usernameCheckRequestRef.current) return;
      setUsernameAvailable(null);
      setUsernameMessage(error.message || 'Unable to check username availability.');
    } finally {
      if (requestId === usernameCheckRequestRef.current) setUsernameChecking(false);
    }
  };

  const handleUsernameSave = async () => {
    if (!usernameEditing || usernameSaving || usernameChecking || !user) return;
    usernameCheckRequestRef.current += 1;
    const nextUsername = usernameDraft.trim();
    setUsernameMessage('');

    if (nextUsername.length < USERNAME_MIN_LENGTH || nextUsername.length > USERNAME_MAX_LENGTH) {
      setUsernameMessage(`Username must be between ${USERNAME_MIN_LENGTH} and ${USERNAME_MAX_LENGTH} characters.`);
      return;
    }

    setUsernameSaving(true);
    try {
      setUsernameMessage('Checking availability…');
      const isAvailable = await checkUsernameAvailability(nextUsername);
      setUsernameAvailable(isAvailable);
      if (!isAvailable) throw new Error('Username is already taken.');

      const token = await user.getIdToken();
      const response = await fetch('/api/username', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ username: nextUsername }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Unable to update username.');

      setUsernameInfo(data.username);
      setUsernameDraft(data.username);
      setUsernameAvailable(true);
      localStorage.setItem('username', data.username);
      setUsernameMessage('Username updated.');
      setUsernameEditing(false);
    } catch (error) {
      setUsernameMessage(error.message || 'Unable to update username.');
    } finally {
      setUsernameSaving(false);
    }
  };

  function obfuscateEmail(email) {
    const [local, domain] = email.split('@');
  
    if (local.length <= 2) {
      return email;
    }
  
    const obfuscatedLocal = `${local[0]}${'*'.repeat(local.length - 2)}${local[local.length - 1]}`;
    return `${obfuscatedLocal}@${domain}`;
  }

  return (
    <div className='col-lg-10 col-sm-12 m-auto'>
      <div className='account-page-switch switch col-4 d-flex justify-content-between align-items-center text-center mt-4 p-1 mb-3'>
        <div className={`mouse-pointer p-2 wallet ${switcher === 'bets' ? 'bg-lightgreen': ''}`} onClick={() => { getBetsHistory(); setSwitcher('bets')}}>Bets</div>
        <div className={`mouse-pointer p-2 account ${switcher === 'account' ? 'bg-lightgreen': ''}`} onClick={() => setSwitcher('account')}>Account</div>

      </div>

      <div className='account-page-panel row bg-green shadow-down rounded py-4 mb-5 match-list m-auto'>
        {order && <div className='col-12 text-orange fst-italic mb-2' role='status'>{message}</div>}
        {switcher === 'account' ? ( 
          <>
          <div className='account-settings-form col-12 matchMarginAccount my-2'>
          <div className="row g-3 align-items-center d-flex">
            <div className="col-4">
              <label htmlFor="usernameContainer" className="col-form-label text-grey text-uppercase">Username</label>
            </div>
            <div className="col-8">
              <div className='d-flex align-items-center justify-content-start'>
                <div className='account-field-control'>
                  <input
                    type="text"
                    id="usernameContainer"
                    ref={usernameInputRef}
                    className="form-control accountInput"
                    readOnly={!usernameEditing || usernameSaving}
                    value={user !== null ? usernameDraft : ''}
                    maxLength={USERNAME_MAX_LENGTH}
                    onChange={(event) => {
                      usernameCheckRequestRef.current += 1;
                      setUsernameChecking(false);
                      setUsernameDraft(event.target.value.slice(0, USERNAME_MAX_LENGTH));
                      setUsernameAvailable(null);
                      setUsernameMessage('');
                    }}
                    onBlur={handleUsernameBlur}
                    onKeyDown={(event) => {
                      if (!usernameEditing) return;
                      if (event.key === 'Enter') {
                        event.preventDefault();
                        handleUsernameSave();
                      } else if (event.key === 'Escape') {
                        event.preventDefault();
                        handleUsernameCancel();
                      }
                    }}
                  />
                </div>
                <div className='account-action-column username-save-action d-flex align-items-center justify-content-center gap-1'>
                  {usernameEditing ? (<>
                  <button
                    type="button"
                    className="username-save-button username-icon-button"
                    aria-label="Save username"
                    title="Save username"
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={handleUsernameSave}
                    disabled={
                      usernameSaving
                      || usernameChecking
                      || usernameAvailable === false
                      || usernameDraft.trim() === usernameInfo
                      || usernameDraft.trim().length < USERNAME_MIN_LENGTH
                    }
                  >
                    <CheckIcon sx={{ fontSize: 16 }} />
                  </button>
                  <button
                    type="button"
                    className="username-save-button username-icon-button"
                    aria-label="Cancel username edit"
                    title="Cancel"
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={handleUsernameCancel}
                    disabled={usernameSaving}
                  >
                    <CloseIcon sx={{ fontSize: 16 }} />
                  </button>
                  </>) : (
                    <button
                      type="button"
                      className="username-save-button username-icon-button"
                      aria-label="Edit username"
                      title="Edit username"
                      onClick={handleUsernameEdit}
                      disabled={!user}
                    >
                      <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              <div className="account-field-message text-orange fst-italic" role="status">
                {usernameMessage}
              </div>
            </div>
          </div>
          <div className="row g-3 align-items-center d-flex mt-3">
            <div className="col-4">
              <label htmlFor="emailContainer" className="col-form-label text-grey text-uppercase">Email</label>
            </div>
            <div className="col-8">
              <div className='col-10 col-sm-11'>
                <input 
                  type="text" 
                  id="emailContainer" 
                  className="form-control accountInput" 
                  value={user !== null ?  obfuscateEmail(user.email) : ''} 
                  disabled
                />       
              </div>
            </div>
          </div>

          <div className="row g-3 align-items-center mt-3">
            <div className="col-4">
              <label htmlFor="pwContainer" className="col-form-label text-grey text-uppercase">Password</label>
            </div>
            <div className="col-8">
              <div className='d-flex align-items-center justify-content-start'>
                <div className='account-field-control bg-darkblue rounded'>
                  <input 
                    type="text" 
                    id="pwContainer" 
                    className="form-control accountInput" 
                    value="******" 
                    disabled
                  />   
                </div>
                <div className='account-action-column editPass p-3 mouse-pointer' onClick={handleResetPassword}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-fill" viewBox="0 0 16 16">
                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                  </svg>
                </div>
              </div>
              <div className="account-field-message text-orange fst-italic" role="status">
                {reset ? 'Check your email for the password reset link.' : ''}
              </div>
            </div>
          </div>
          <div className="row g-3 align-items-center mt-3">
            <div className="col-4">
              <div className="col-form-label text-grey text-uppercase d-flex align-items-center">
                <span id="walletLabel" className="fw-bold">Wallet</span>
                <ClickAwayListener onClickAway={() => setWalletInfoPinned(false)}>
                  <span>
                    <Tooltip
                      title="This website is a fantasy betting platform designed for entertainment and educational purposes only. The bets you make here use virtual currency, and any gains or losses are purely fictional."
                      placement={isPhone ? 'bottom' : 'right-end'}
                      arrow
                      open={walletInfoPinned || walletInfoHovered}
                      onOpen={() => setWalletInfoHovered(true)}
                      onClose={() => setWalletInfoHovered(false)}
                      disableFocusListener
                      disableTouchListener
                      slotProps={{
                        tooltip: {
                          sx: {
                            maxWidth: isPhone ? 'calc(100vw - 32px)' : 300,
                          },
                        },
                        popper: {
                          modifiers: [
                            {
                              name: 'preventOverflow',
                              options: { boundary: 'viewport', padding: 16 },
                            },
                          ],
                        },
                      }}
                    >
                      <IconButton
                        type="button"
                        aria-label="About the virtual wallet"
                        aria-expanded={walletInfoPinned}
                        onClick={() => setWalletInfoPinned((isOpen) => !isOpen)}
                        sx={{ fontSize: 15 }}
                      >
                        <InfoIcon sx={{ fontSize: 15 }}/>
                      </IconButton>
                    </Tooltip>
                  </span>
                </ClickAwayListener>
              </div>
            </div>
            <div className='col-8 d-flex align-items-center justify-content-start'>
              <div className="account-field-control d-flex align-items-stretch justify-content-between balanceInput">
                  <div className='inputDiv'><input pattern="^\d*(\.\d{0,2})?$" className='input inputBet fw-bold' id="walletBalance" aria-labelledby="walletLabel" value={walletBalance} disabled/></div>
                  <div className='currency'><img src = {currency} className='currencyImg' alt='coins' width = {20} height={20}/></div>
              </div>
              <div className='account-action-column p-3 mouse-pointer addCoins'
              onClick={openAddCoinsModal}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
              </svg>
              </div>
            </div>

          </div>
          <div className="row g-3 align-items-center d-flex mt-3">
            <div className="col-4">
              <label htmlFor="marketingEmails" className="col-form-label text-grey text-uppercase">
                Marketing emails
              </label>
            </div>
            <div className="col-8">
              <div className="form-check form-switch text-white">
                <input
                  id="marketingEmails"
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={marketingOptIn}
                  disabled={marketingPreferenceLoading}
                  onChange={(event) => handleMarketingPreferenceChange(event.target.checked)}
                />
                <label className="form-check-label font-12" htmlFor="marketingEmails">
                  Receive FantasyBet news, offers and marketing emails.
                </label>
              </div>
              <div className="account-field-message text-orange" role="status">
                {marketingPreferenceMessage}
              </div>
            </div>
          </div>
          <div className='row g-3 alignt-items-center justify-content-start my-1'>
            <div className='col-12 text-end'> 
              <button onClick={handleLogOut} className='btn border sfw-bold text-white py-2 px-5 logout'>Logout</button>

            </div>
            
          </div>

          </div>
          {/* <div className='col-12 col-xxl-7 matchMarginAccount'>
            <div className='d-flex justify-content-between align-items-center'>
              <div className='col-md-4 col-6'><label className="col-form-label text-grey text-uppercase">Transaction History</label></div>
              <div className='col-md-8 col-6 key text-white text-end font-10'><span className='badge bg-success'>&nbsp;</span> Won <span className='badge bg-danger'>&nbsp;</span> Lost <br/><span className='badge bg-dark'>&nbsp;</span> Settled  <span className='badge bg-secondary'>&nbsp;</span> Pending </div>
            </div>
            <div className='tableWrap'>
              {transactions.length > 0 ? (
                <table size="sm" className='transactions'>
                <thead>
                  <tr>
                    <th>DATE</th>
                    <th>AMOUNT</th>
                    <th>TRANSACTION TYPE</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((transaction) => {
                  return transaction.transaction_type === "bet" ? (
                    <tr key={transaction.transaction_id}>
                      <td>{new Date(transaction.transaction_date).toLocaleString().split(",")[0]} </td>
                      <td>- {transaction.amount}</td>
                      <td><span className=''>Bet</span></td>
                      <td> <span className={`badge ${
                        transaction.status === 'pending'
                          ? 'bg-secondary'
                          : 'bg-dark'
                      }`}>
                        &nbsp;
                    </span>
                      </td>
                    </tr>
                  ) : transaction.transaction_type === "win" || transaction.transaction_type === "loss" ? 
                  (
                    <tr key={transaction.transaction_id}>
                      <td>{new Date(transaction.transaction_date).toLocaleString().split(",")[0]} </td>
                      <td className={`${transaction.status === 'won' ? 'text-green' : 'text-red'}`} >{transaction.status === 'won' ? ' + ' : ' - '}{transaction.amount}</td>
                      <td><span className=''>Result</span></td>
                      <td> <span className={`badge ${
                        transaction.status === 'pending'
                          ? 'bg-secondary'
                          : transaction.status === 'won'
                          ? 'bg-success'
                          : transaction.status === 'lost'
                          ? 'bg-danger'
                          : ''
                      }`}>
                          &nbsp;
                        </span>
                      </td>
                    </tr>
                  ) : (
                    <tr key={transaction.transaction_id}>
                      <td>{new Date(transaction.transaction_date).toLocaleString().split(",")[0]} </td>
                      <td>{transaction.transaction_type === 'deposit' ? ' + ' : ' - '}{transaction.amount}</td>
                      <td><span className='text-capitalize'>{transaction.transaction_type}</span></td>
                      <td></td>
                    </tr>
                  ) 
                  } 
                  )}
                </tbody>
              </table>
              ) : (
                <>
                <table size="sm" className='transactions'>
                <thead>
                  <tr>
                    <th>DATE</th>
                    <th>AMOUNT</th>
                    <th>TRANSACTION TYPE</th>
                    <th></th>
                  </tr>
                </thead>
                </table>
                <div className='text-center mt-5'>
                  <p className='text-white'><em>Empty...</em> <br/>
                      <strong>Start Betting!</strong>
                  </p>
                  <img src = {empty} alt='Empty...' width = {160} height={150}/>
                </div>
                </>
              )}
            </div>
          </div> */}
          </>
        ) : (
          <>
          <div className={`bets-history-container col-12 matchMarginAccount ${isBetHistoryCardView ? 'is-card-view' : ''} ${isBetHistoryDataLoading || isBetHistoryLayoutPending ? 'is-layout-pending' : ''}`}>
            {(isBetHistoryDataLoading || isBetHistoryLayoutPending) && (
              <div className="bets-history-layout-spinner" role="status" aria-live="polite">
                <div className="spinner-border" aria-hidden="true"></div>
                <span className="visually-hidden">Preparing bets history layout...</span>
              </div>
            )}
            <div className='bets-history-toolbar w-100 mb-1'>
              <div className='searchBet'>
                <div className="mb-1 searchgroup w-100 text-end d-flex align-items-center">
                  <span className="searchgroup-text" id="basic-addon1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" 
                        fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                      </svg>
                    </span>
                  <input type="text" className="search" placeholder="Search..."  onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} />
                </div>
              </div>
              <div className='bets-history-toolbar-meta'>
                <div className='text-white text-end key'>
                  <span className="status-item"><span className='badge bg-secondary'>&nbsp;</span> Pending</span>
                  <span className="status-item"><span className='badge bg-success'>&nbsp;</span> Won</span>
                  <span className="status-item"><span className='badge bg-danger'>&nbsp;</span> Lost</span>
                  <span className="status-item"><span className='badge bg-dark'>&nbsp;</span> Void</span>
                </div>
              </div>
              <BetHistoryFilter filterType={filterType} setFilterType={setFilterType} className="bets-history-primary-filter" />
            </div>
            <div className='bets-history-net-profit-row text-white'>
              <span>Net Profit</span>
              <strong className={netProfit > 0 ? 'text-green' : netProfit < 0 ? 'text-red' : 'text-white'}>
                {netProfit >= 0 ? '+' : ''}{netProfit.toFixed(2)}
              </strong>
            </div>
            <div ref={betHistoryTableWrapRef} className={`tableWrap ${isBetHistoryCardView ? 'is-card-view' : ''}`}>
              <div className="bet-history-card-controls">
                <button type="button" className="bet-history-card-date-sort" onClick={toggleSortOrder}>
                  {sortOrder === 'asc' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-up" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                    </svg>
                  )}
                  <span>Date</span>
                </button>
                <BetHistoryFilter filterType={filterType} setFilterType={setFilterType} className="bet-history-card-filter" />
              </div>
              {sortedBets.length > 0 ? (
                <table ref={betHistoryTableRef} size="sm" className='transactions'>
                <thead>
                  <tr>
                    <th onClick={toggleSortOrder} className="mouse-pointer">
                      <div className='d-flex align-items-center justify-content-start'>
                        <div className='me-2'> {sortOrder === 'asc' ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-up" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                          </svg>
                          ) : ( 
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                          </svg>
                          )}
                        </div>
                        <div>Date</div>
                      </div>
                    </th>                    
                    <th>Bet Amount</th>
                    <th>Profit</th>
                    <th style={{width: '50%'}}>Bet Type</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedBets.map((bet) =>
                    bet.transaction_type === "bet" ? (
                    <tr key={bet.bet_id}>
                      <td data-label="Date"><div className="bet-history-value">{formatBetHistoryDate(bet.placed_at)} <br/> -</div></td>
                      <td data-label="Bet Amount"><div className="bet-history-value">{bet.bet_amount}</div></td>
                      <td data-label="Profit"><div className="bet-history-value">{(bet.potential_payout - bet.bet_amount).toFixed(2)}</div></td>
                      <td data-label="Bet Type"><div className="bet-history-value"><span className='fst-italic'> {bet.fixture}</span> <br/> <span className='fst-italic '>{bet["bet_market"]}</span> <br/> <span className='fw-bold text-orange'> {bet["bet_type"]} </span></div></td>
                      <td data-label="Status" className='badges'>
                        <div className="bet-history-value bet-history-status">
                          <span className={`badge ${bet.status === 'pending' ? 'bg-secondary' : 'bg-dark'}`}>&nbsp;</span>
                          <span className="bet-history-status-text">{bet.status}</span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr key={bet.transaction_id}>
                      <td data-label="Date"><div className="bet-history-value">{formatBetHistoryDate(bet.placed_at)} <br />{formatBetHistoryDate(bet.settled_at)}</div></td>
                      <td data-label="Bet Amount"><div className="bet-history-value">{bet.bet_amount}</div></td>
                      <td data-label="Profit"><div className={`bet-history-value ${bet.status === 'won' ? 'text-green fw-bold' : bet.status === 'void' ? 'text-lightgreen' : 'text-red fw-bold'}`}>{`${bet.status === 'lost' ? '-'+bet.bet_amount : bet.status === "void" ? '0.00' : '+'+(bet.potential_payout - bet.bet_amount).toFixed(2)}`}</div></td>
                      <td data-label="Bet Type"><div className="bet-history-value">
                        <span className='fst-italic'> {bet.fixture}</span> <br />
                        <span className='fst-italic '>{bet["bet_market"]}</span> <br />
                        <span className='fw-bold text-orange'> {bet["bet_type"]} </span>
                      </div></td>
                      <td data-label="Status" className='badges'>
                        <div className="bet-history-value bet-history-status">
                          <span className={`badge ${bet.status === 'pending' ? 'bg-secondary' : bet.status === 'won' ? 'bg-success' : bet.status === 'void' ? 'bg-dark' : 'bg-danger'}`}>&nbsp;</span>
                          <span className="bet-history-status-text">{bet.status}</span>
                        </div>
                      </td>
                    </tr>
                  )
                )}
                </tbody>
              </table>
              ) : (
              <>
              <table ref={betHistoryTableRef} size="sm" className='transactions'>
                <thead>
                  <tr>
                    <th onClick={toggleSortOrder} className="mouse-pointer">
                      <div className='d-flex align-items-center justify-content-start'>
                        <div className='me-2'> {sortOrder === 'asc' ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-up" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                          </svg>
                          ) : ( 
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                          </svg>
                          )}
                        </div>
                        <div>Date</div>
                      </div>
                    </th>                    
                    <th>Bet Amount</th>
                    <th>Profit</th>
                    <th>Bet Type</th>
                    <th></th>
                  </tr>
                </thead>
              </table>
              <div className='text-center mt-5'>
                <p className='text-white'><em>Empty...</em> <br/>
                    <strong>Start Betting!</strong>
                </p>
                <img src = {empty} alt='Empty...' width = {214} height={200} />
              </div>
              </>
              )}
            {sortedBets.length > 0 && (
              <nav className="bets-history-pagination pagination mt-2 d-flex flex-wrap justify-content-center align-items-center gap-3 my-1" aria-label="Bets history pages">
                <button
                  type="button"
                  onClick={() => changeBetHistoryPage(safeBetHistoryPage - 1)}
                  disabled={safeBetHistoryPage === 1}
                  className="btn btn-sm"
                >
                  Prev
                </button>
                <span aria-live="polite">
                  Page {safeBetHistoryPage} of {totalBetHistoryPages}
                </span>
                <button
                  type="button"
                  onClick={() => changeBetHistoryPage(safeBetHistoryPage + 1)}
                  disabled={safeBetHistoryPage === totalBetHistoryPages}
                  className="btn btn-sm"
                >
                  Next
                </button>
              </nav>
            )}
            </div>
          </div>
          </>
        )}
      </div>
    </div>
  );
}
